// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"bc9b2971","186":"2232bb52","225":"08ec8094","344":"2f81bc64","372":"08e6495b","377":"92848639","738":"06ec4937","841":"9b7ef3c3","856":"0585f9ea"}[chunkId] + ".chunk.js";
};